import {Box, FormControl, FormLabel, Input, Textarea} from "@chakra-ui/react";
import {useEffect} from "react";

interface TextInputProps {
    id: string;
    label: string;
    value: string;
    name: string;
    formObject: Record<string, any>;
    setFormObject: (formObject: Record<string, any>) => void;
    inputProps?: Record<string, any>;
    isTextarea?: boolean; // ✅ Add this
    isDisabled?: boolean;
    type?: "text" | "number" | "date" | "datetime" | "datetime-local";
    min?: string | ''
}

const TextInput = ({
                       id,
                       label,
                       value,
                       name,
                       formObject,
                       setFormObject,
                       inputProps = {},
                       isTextarea = false,
                       isDisabled = false,
                       type,
                       min
                   }: TextInputProps) => {
    function handleChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        setFormObject({
            ...formObject,
            [name]: event.target.value,
        });
    }

    useEffect(() => {
        console.log("form object value is ::: ", formObject);
    }, [formObject]);

    return (
        <Box width="100%">
            <FormControl id={id}>
                <FormLabel fontWeight="medium">{label}</FormLabel>
                {isTextarea ? (
                    <Textarea
                        name={name}
                        value={value}
                        onChange={handleChange}
                        {...inputProps}
                        disabled={isDisabled}
                    />
                ) : (
                    <Input
                        name={name}
                        value={value}
                        onChange={handleChange}
                        type={type}
                        variant="outline"
                        {...inputProps}
                        disabled={isDisabled}
                        min={min}
                    />
                )}
            </FormControl>
        </Box>
    );
};

export default TextInput;
